/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'blogPost',
	title: 'Blog Post',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'slug',
			title: 'Slug',
			type: 'slug',
			options: {
				source: 'title',
				maxLength: 96,
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'author',
			title: 'Author',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'category',
			title: 'Category',
			type: 'string',
			options: {
				list: [
					{ title: 'Storytelling', value: 'Storytelling' },
					{ title: 'Confidence', value: 'Confidence' },
					{ title: 'Communication', value: 'Communication' },
					{ title: 'General', value: 'General' },
				],
				default: 'General',
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'publishedAt',
			title: 'Published at',
			type: 'datetime',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'readTime',
			title: 'Read Time',
			type: 'string',
			description: 'E.g., "5 min read"',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'featuredImage',
			title: 'Featured Image',
			type: 'image',
			options: {
				hotspot: true,
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'excerpt',
			title: 'Excerpt',
			type: 'text',
			validation: (Rule: any) => Rule.max(200).warning('Keep excerpts concise'),
		},
		{
			name: 'content',
			title: 'Content',
			description:
				'The main content of the blog post. Use Shift+Enter for line breaks.',
			type: 'array',
			of: [
				{
					type: 'block',
					styles: [
						{ title: 'Normal', value: 'normal' },
						{ title: 'Heading 1', value: 'h1' },
						{ title: 'Heading 2', value: 'h2' },
						{ title: 'Heading 3', value: 'h3' },
						{ title: 'Quote', value: 'blockquote' },
					],
				},
				{ type: 'image' },
			],
		},
		{
			name: 'isFeatured',
			title: 'Is Featured (Hero article)',
			type: 'boolean',
			default: false,
		},
	],
	preview: {
		select: {
			title: 'title',
			author: 'author',
			media: 'featuredImage',
			publishedAt: 'publishedAt',
		},
		prepare(selection: any) {
			const { author, publishedAt } = selection;
			return {
				...selection,
				subtitle:
					author && publishedAt
						? `by ${author} • ${new Date(publishedAt).toLocaleDateString()}`
						: author
							? `by ${author}`
							: '',
			};
		},
	},
};
